import { Icon } from "@ospweb/sdk-ui";
import React from "react";
import { cn } from "utils";
import { RealTimeResultProps } from "./types";
import Translations from "@translate/components/RealTimeResult/RealTimeResult";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export const RealTimeResult = ({
  className,
  style,
  text,
  onClick,
}: RealTimeResultProps): React.JSX.Element => {
  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡
    onClick?.();
  };

  return (
    <div
      className={cn(
        "inline-flex items-center justify-between rounded-lg p-3 w-full",
        "bg-background_brand_overlay5", // background and border colors from theme
        className,
      )}
      style={style}
    >
      <div className="flex flex-row items-center gap-2 ">
        <Icon name="Alerts" size={20} className="text-content_brand_primary" />
        <p className={cn("body_m text-content_warning flex-1")}>
          {I18n.t("Results from data up to %{var0}", {
            var0: text,
          })}
        </p>
      </div>
      <div
        data-openreplay-label="misc_realtimeresult_click"
        className="px-3 py-2 button_m gradient-border-member flex gap-0.5 flex-row items-center cursor-pointer rounded-2 bg-background_solid_secondary"
        onClick={handleClick}
      >
        <Icon name="pricing" size={16} className="text-content_brand_primary" />
        <span className="text-gradient">{I18n.t("Get Real-Time Result")}</span>
      </div>
    </div>
  );
};
